<button
  id="scrollToTop"
  class="fixed bottom-8 right-8 bg-primary-600 text-white p-3 rounded-full shadow-lg opacity-0 invisible transition-all duration-300 hover:bg-primary-700 focus:outline-none transform hover:scale-110 z-50"
  aria-label="Scroll to top"
  (click)="scrollToTop()"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 10l7-7m0 0l7 7m-7-7v18"
    ></path>
  </svg>
</button>

<footer class="bg-footer-gradient text-white pt-10 pb-6">
  <div class="container mx-auto px-4">
    <div class="flex flex-col md:flex-row justify-between mb-4">
      <div class="mb-8 md:mb-0 md:w-1/2 text-center md:flex md:justify-center">
        <div class="flex flex-col items-center md:items-start">
          <div class="flex flex-col md:flex-row items-center md:items-start mb-4">
            <img
              src="assets/images/mli-logo-white.svg"
              alt="MLI Education Logo"
              class="h-16 lg:h-20 mb-4 md:mb-0 md:mr-6"
            />
            <div>
              <div class="text-base lg:text-lg text-center md:text-left">
                <span class="whitespace-nowrap font-bold">Medical Learning Institute Inc</span
                ><br />
                <span class="whitespace-nowrap">40946 US Highway 19N, #602</span><br />
                <span class="whitespace-nowrap">Tarpon Springs, FL 34689</span>
              </div>

              <div
                class="social-media-icons flex flex-wrap justify-center md:justify-start gap-1 mt-2"
              >
                <a
                  href="https://www.facebook.com/mlieducation.fb.social/"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-icon bg-secondary-600 hover:bg-blue-600 p-2 rounded-md transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="h-5 w-5 fill-current text-white"
                  >
                    <path
                      d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://twitter.com/mlieducation"
                  aria-label="X"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-icon bg-secondary-600 hover:bg-black p-2 rounded-md transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    class="h-5 w-5 fill-current text-white"
                  >
                    <path
                      d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/medical-learning-institute-inc/"
                  aria-label="Linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-icon bg-secondary-600 hover:bg-blue-700 p-2 rounded-md transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="h-5 w-5 fill-current text-white"
                  >
                    <path
                      d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/mlieducation"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-icon bg-secondary-600 hover:bg-purple-600 p-2 rounded-md transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="h-5 w-5 fill-current text-white"
                  >
                    <path
                      d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.threads.net/@mlieducation"
                  aria-label="Threads"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-icon bg-secondary-600 hover:bg-gray-900 p-2 rounded-md transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    class="h-5 w-5 fill-current text-white"
                  >
                    <path
                      d="M105 0h302c57.75 0 105 47.25 105 105v302c0 57.75-47.25 105-105 105H105C47.25 512 0 464.75 0 407V105C0 47.25 47.25 0 105 0z M337.36 243.58c-1.46-.7-2.95-1.38-4.46-2.02-2.62-48.36-29.04-76.05-73.41-76.33-25.6-.17-48.52 10.27-62.8 31.94l24.4 16.74c10.15-15.4 26.08-18.68 37.81-18.68h.4c14.61.09 25.64 4.34 32.77 12.62 5.19 6.04 8.67 14.37 10.39 24.89-12.96-2.2-26.96-2.88-41.94-2.02-42.18 2.43-69.3 27.03-67.48 61.21.92 17.35 9.56 32.26 24.32 42.01 12.48 8.24 28.56 12.27 45.26 11.35 22.07-1.2 39.37-9.62 51.45-25.01 9.17-11.69 14.97-26.84 17.53-45.92 10.51 6.34 18.3 14.69 22.61 24.73 7.31 17.06 7.74 45.1-15.14 67.96-20.04 20.03-44.14 28.69-80.55 28.96-40.4-.3-70.95-13.26-90.81-38.51-18.6-23.64-28.21-57.79-28.57-101.5.36-43.71 9.97-77.86 28.57-101.5 19.86-25.25 50.41-38.21 90.81-38.51 40.68.3 71.76 13.32 92.39 38.69 10.11 12.44 17.73 28.09 22.76 46.33l28.59-7.63c-6.09-22.45-15.67-41.8-28.72-57.85-26.44-32.53-65.1-49.19-114.92-49.54h-.2c-49.72.35-87.96 17.08-113.64 49.73-22.86 29.05-34.65 69.48-35.04 120.16v.24c.39 50.68 12.18 91.11 35.04 120.16 25.68 32.65 63.92 49.39 113.64 49.73h.2c44.2-.31 75.36-11.88 101.03-37.53 33.58-33.55 32.57-75.6 21.5-101.42-7.94-18.51-23.08-33.55-43.79-43.48zm-76.32 71.76c-18.48 1.04-37.69-7.26-38.64-25.03-.7-13.18 9.38-27.89 39.78-29.64 3.48-.2 6.9-.3 10.25-.3 11.04 0 21.37 1.07 30.76 3.13-3.5 43.74-24.04 50.84-42.15 51.84z"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://bsky.app/profile/mlieducation.bsky.social"
                  aria-label="Bluesky"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-icon bg-secondary-600 hover:bg-blue-500 p-2 rounded-md transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 600 530"
                    class="h-5 w-5 fill-current text-white"
                  >
                    <path
                      d="m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:w-1/2 text-center md:text-left">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-4">
          <div>
            <h4 class="uppercase font-bolder mb-2 text-gray-200">Learning with MLI</h4>
            <ul class="space-y-1">
              <li><a href="/" class="hover:text-blue-300 transition-colors">All Courses</a></li>
              <li>
                <a href="https://app.cesessions.org/" class="hover:text-blue-300 transition-colors"
                  >Live Events</a
                >
              </li>
              <li>
                <a [routerLink]="'/privacy-policy'" class="hover:text-blue-300 transition-colors"
                  >Privacy Policy</a
                >
              </li>
              <li>
                <a [routerLink]="'/terms-of-service'" class="hover:text-blue-300 transition-colors"
                  >Terms of Service</a
                >
              </li>
            </ul>
          </div>
          <div>
            <h4 class="uppercase font-bolder mb-2 text-gray-200">About MLI</h4>
            <ul class="space-y-1">
              <li>
                <a
                  target="_blank"
                  href="https://www.mlieducation.org/about-us/"
                  class="hover:text-blue-300 transition-colors"
                  >About Us</a
                >
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.mlieducation.org/contact-us/"
                  class="hover:text-blue-300 transition-colors"
                  >Contact</a
                >
              </li>
              <li>
                <a
                  href="https://www.mlieducation.org/societies-and-partners/"
                  class="hover:text-blue-300 transition-colors"
                  >Societies and Partners</a
                >
              </li>
              <li>
                <a
                  href="https://www.mlieducation.org/accreditation/"
                  class="hover:text-blue-300 transition-colors"
                  >Accreditation</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center text-sm">
      <span class="whitespace-nowrap">Copyright &copy;{{ currentYear }}</span>
      <span class="whitespace-nowrap">&nbsp;Medical Learning Institute Inc.&nbsp;</span>
      <span class="whitespace-nowrap">All Rights Reserved.</span>
    </div>
  </div>
</footer>
